import { auth } from '@/http';
import services from '@/http';
import { hasError } from "@/utils/helpers";
import * as types from './mutation-types';
import * as storage from '../storage';
import { sendAbandonmentBeacon, resolveOwnerIdFromEnv } from '@/utils/abandonmentBeacon';

export const ActionSendPromoCode = (context, payload) => {
    auth.sendPromoCode.data = payload;
    return services.http.request(auth.sendPromoCode)
                .then((result) => {
                    return result;
                })
                .catch((err) => {
                    return err;
                });
}

export const ActionGetMailingFirstName = (context, payload) => {
    auth.getMailingFirstName.data = payload;
    return services.http.request(auth.getMailingFirstName)
                .then((result) => {
                    return result;
                })
                .catch((err) => {
                    return err;
                });
}

export const ActionGetContactsByDocNumber = (context, payload) => {
    auth.getContacts.data = payload;
    return services.http.request(auth.getContacts)
                .then((result) => result)
                .catch((error) => error);
}

export const ActionCreateDebtor = (context, payload) => {
    auth.insertDebtor.data = payload;
    return services.http.request(auth.insertDebtor);
}

export const ActionIsHomolog = () => {
    return process.env.VUE_APP_HOMOLOG;
}
export const ActionDoRegisterSession = () => {
    // registra CSRF Cookies
    return services.http.request(auth.registerCookie);
}

export const ActionMailingDoLogin = async ({ dispatch }, payload) => {
    //dispatch('ActionSetLoading', true);
    auth.mailinglogin.data = payload;
    await services.http.request(auth.mailinglogin)
        .then(async response => {
            dispatch("ActionSetGuest", { value: "isNotGuest" });
            dispatch("ActionSetToken", response.data.token);
            dispatch("ActionSetTag", response.data.tag);
            dispatch("ActionSetOwnerId", resolveOwnerIdFromEnv());

            await services.http.request(auth.getUser)
                .then(response => {
                    dispatch('ActionSetUser', response.data.results);
                    //dispatch('ActionSetLoading', false);
                })
                .catch(error => {
                    dispatch('ActionSetError', hasError(error));
                });
        })
        .catch((error) => {
            dispatch('ActionSetError', hasError(error));
            //dispatch('ActionSetLoading', false);
            throw error;
        });
}


export const ActionGetIPAddress = async () => {
    return await fetch('https://api.ipify.org?format=json')
    .then(x => x.json())
    .then(({ ip }) => {
        return ip;
    });
}


export const ActionDoLogin = async ({ dispatch }, payload) => {
    //dispatch('ActionSetLoading', true);
    auth.login.data = payload;
    await services.http.request(auth.login)
        .then(async response => {
            dispatch("ActionSetGuest", { value: "isNotGuest" });
            dispatch("ActionSetToken", response.data.token);
            dispatch("ActionSetTag", "Padrao");
            dispatch("ActionSetOwnerId", resolveOwnerIdFromEnv());

            await services.http.request(auth.getUser)
                .then(response => {
                    dispatch('ActionSetUser', response.data.results);
                    //dispatch('ActionSetLoading', false);
                })
                .catch(error => {
                    dispatch('ActionSetError', hasError(error));
                });
        })
        .catch((error) => {
            dispatch('ActionSetError', hasError(error));
            //dispatch('ActionSetLoading', false);
            throw error;
        });
}

export const ActionGetUser = async ({ dispatch }) => {

    const user = localStorage.getItem('authUser');

    if (user) {
      dispatch('ActionSetUser', JSON.parse(user));
      dispatch('ActionSetOwnerId', resolveOwnerIdFromEnv());
      dispatch('ActionSetLoading', false);
      return;
    }

    return await services.http.request(auth.getUser)
        .then(response => {
            dispatch('ActionSetUser', response.data.results);
            dispatch('ActionSetOwnerId', resolveOwnerIdFromEnv());
            dispatch('ActionSetLoading', false);
        })
        .catch(error => {
            dispatch('ActionSetError', hasError(error));
        });
}

export const ActionDoLogout = ({ dispatch, state }, { skipBeacon = false } = {}) => {
    if (!skipBeacon) {
        const user    = state.user;
        const ownerId = state.ownerId;
        if (user?.DebtorID && ownerId) {
            sendAbandonmentBeacon(
                user.DebtorID,
                ownerId,
                user.PhoneNumber || null,
                'LOGOUT',
            );
        }
    }

    storage.setHeaderToken('');
    storage.deleteLocalToken();
    localStorage.clear();
    dispatch('ActionSetUser', null);
    dispatch('ActionSetToken', null);
    dispatch('ActionSetOwnerId', null);
    dispatch("ActionSetGuest", { value: "isGuest" });
    location.reload();
}

export const ActionCheckToken = ({dispatch, state}) => {
    dispatch('ActionSetLoading', true);
    if (state.token) {
        dispatch('ActionSetLoading', false);
        return Promise.resolve(state.token);
    }

    const token = storage.getLocalToken();
    
    if(!token) {
        dispatch('ActionSetLoading', false);
        return Promise.reject(hasError("Token Inválido!"));
    }

    dispatch('ActionSetToken', token);
    return dispatch('ActionGetUser');
}


// export const ActionGetWhatsText = ({dispatch}) => {
//     dispatch('ActionSetLoading', true);
//     return services.http.request(auth.whatsText)
//         .then(response => {
//             dispatch('ActionSetLoading', false);
//             return response.data.results;
//         })
//         .catch((err) => {
//             dispatch('ActionSetLoading', false);
//             return err;
//         });
// }

export const ActionLogContato = (context, payload) => {
    auth.logContato.data = payload;
    return services.http.request(auth.logContato)
                .then((result) => result)
                .catch((error) => error);
}

export const ActionGetWhatsText = (context, payload) => {
    auth.whatsText.data = payload;
    return services.http.request(auth.whatsText)
                .then((result) => result)
                .catch((error) => error);
}

export const ActionSendLogWhatsappWithoutToken = (context, payload) => {
    auth.sendLogWhatsappWithoutToken.data = payload;

    return services.http.request(auth.sendLogWhatsappWithoutToken)
        .then(response => {
            return response;
        })
        .catch((err) => {
            return err;
        });
}

export const ActionGetLinkAccessAsDebtor = (context, payload) => {
    auth.getLinkAccess.data = payload;
    
    return services.http.request(auth.getLinkAccess)
        .then(response => {
            return response.data.results;
        })
        .catch((err) => {
            return err;
        });
}


export const ActionSetUser = ({ commit }, user) => {
    commit(types.SET_USER, user);
}

export const ActionSetLoading = ({ commit }, loading) => {
    commit(types.SET_LOADING, loading);
}

export const ActionSetError = ({ commit }, error) => {
    commit(types.SET_ERROR, error);
}

export const ActionSetCurrentForm = ({ commit }, currentForm) => {
    commit(types.SET_CURRENTFORM, currentForm);
}

export const ActionSetContacts = ({ commit }, contacts) => {
    commit(types.SET_CONTACTS, contacts);
}

export const ActionSetWhatsText = ({ commit }, text) => {
    commit(types.SET_WHATSTEXT, text);
}

export const ActionSetOwnerId = ({ commit }, ownerId) => {
    commit(types.SET_OWNER_ID, ownerId);
}

export const ActionSetGuest = (context, {value}) => {
    window.localStorage.setItem("guest", value);
}

export const ActionSetToken = ({commit}, token) => {
    storage.setLocalToken(token);
    storage.setHeaderToken(token);
    commit(types.SET_TOKEN, token);
}

export const ActionSetTag = (context, tag) => {
    window.localStorage.setItem('tag', tag);
}

export const isGuest = () => {
    const storageItem = window.localStorage.getItem("guest");
    if (!storageItem) return false;
    if (storageItem === "isGuest") return true;
    if (storageItem === "isNotGuest") return false;
}